import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import VueFeather from 'vue-feather';
import Fragment from 'vue-fragment';
import VuetifyGoogleAutocomplete from 'vuetify-google-autocomplete';
import * as VueGoogleMaps from 'vue2-google-maps'
import { initializeApp } from "firebase/app";
import vuetify from './plugins/vuetify';
import store from './state';

const Homepage = () => import("@/views/home");
const Help = () => import("@/views/help");
const AboutUs = () => import("@/views/about-us");
const tc = () => import("@/views/tc");
const driver = () => import("@/components/driver");

const firebaseConfig = {
  apiKey: "AIzaSyAnE1Q6058-GTlc9tK4cmbGX0EvqvflM8U",
  authDomain: "dash-waste-usa.firebaseapp.com",
  projectId: "dash-waste-usa",
  storageBucket: "dash-waste-usa.appspot.com",
  messagingSenderId: "537916132916",
  appId: "1:537916132916:web:9dca4451ea145366f10461",
  measurementId: "G-LWSFB7HR2B"
};

initializeApp(firebaseConfig);

Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.use(VueFeather)
Vue.use(Fragment.Plugin)
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyB2xcq18UZ60nYqMNnU4E6Mv7nhrEjxAXo',
    libraries: 'places',
    installComponents: true
  }
})

Vue.use(VuetifyGoogleAutocomplete, {
  apiKey: 'AIzaSyB2xcq18UZ60nYqMNnU4E6Mv7nhrEjxAXo'
});

const router = new VueRouter({
  mode: 'history',
  routes: [{
    path: '/',
    component: Homepage
  }, {
    path: '/help',
    component: Help
  },{
    path: '/tc',
    component: tc
  }, {
    path: '/about',
    component: AboutUs
  }, {
    path: '/driver',
    component: driver
  }]
})

new Vue({
  render: h => h(App),
  vuetify,
  router,
  store
}).$mount('#app')
